let echarts = require('echarts')

export const initOptionBar1 = function (xData, legendData, barData) {
  let option = {}
  option.color = ['#0c28b8', '#2e5cc6', '#beb390', '#b87e4f']
  option.grid = {
    right: '25%',
    top: '10%',
    bottom: '13%',
    left: 130
  }
  option.tooltip = {
    show: true
  }
  option.legend = {
    data: legendData,
    orient: 'vertical',
    right: '10%',
    top: '10%',
    textStyle: {
      color: '#fff'
    }
  }
  option.xAxis = [{
    type: 'category',
    data: xData,
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    axisLabel: {
      height: '10px'
    },
    axisTick: {
      show: false
    }
  }]
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#fff'
    },
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    splitLine: {
      show: false
    },
    axisTick: {
      inside: true
    }
  }]
  option.series = []
  barData.forEach((item, index) => {
    let oneData = {
      name: legendData[index],
      type: 'bar',
      data: item,
      barWidth: '10px',
      barGap: 0.6,
      itemStyle: {
        barBorderRadius: [5, 5, 0, 0]
      }
    }
    option.series.push(oneData)
  })
  return option
}

export const initOptionBar2 = function (xData, legendData, barData, barData2) {
  let option = {}
  option.color = ['#ff0000', '#ff6e00', '#168fff']
  option.grid = {
    right: '25%',
    top: '10%',
    bottom: '22%',
    left: 130
  }
  option.tooltip = {
    show: true
  }
  option.legend = {
    data: legendData,
    orient: 'vertical',
    right: '10%',
    top: '10%',
    textStyle: {
      color: '#fff'
    }
  }
  option.xAxis = [{
    type: 'category',
    data: xData,
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    axisLabel: {
      rotate: -25,
      fontSize: 10
    },
    axisTick: {
      show: false
    }
  }]
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#fff'
    },
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    splitLine: {
      show: false
    },
    axisTick: {
      inside: true
    }
  }]
  option.series = []
  barData.forEach((item, index) => {
    let oneData = {
      name: legendData[index + 1],
      type: 'bar',
      stack: '总量',
      data: item,
      barWidth: '13px',
      barGap: 0.3
    }
    option.series.push(oneData)
  })
  barData2.forEach((item, index) => {
    let oneData = {
      name: legendData[index],
      type: 'bar',
      data: item,
      barWidth: '13px',
      barGap: 0.3
    }
    option.series.push(oneData)
  })
  return option
}

export const initOptionBar3 = function (xData, barData) {
  let option = {}
  option.color = ['#168fff']
  option.grid = {
    right: 35,
    top: '10%',
    bottom: '22%',
    left: '18%'
  }
  option.tooltip = {
    show: true
  }
  option.xAxis = [{
    type: 'category',
    data: xData,
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    axisLabel: {
      rotate: -25,
      fontSize: 10
    },
    axisTick: {
      show: false
    }
  }]
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#fff'
    },
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: 'rgba(255,255,255,0.1)'
      }
    },
    axisTick: {
      inside: false
    }
  }]
  option.series = []
  barData.forEach((item, index) => {
    let oneData = {
      type: 'bar',
      data: item,
      barWidth: '10px',
      barGap: 0.6,
      itemStyle: {
        barBorderRadius: [5, 5, 0, 0]
      }
    }
    option.series.push(oneData)
  })
  return option
}

export const initOptionBar4 = function (xData, barData) {
  let option = {}
  option.grid = {
    right: 35,
    top: '10%',
    bottom: '22%',
    left: '18%'
  }
  option.tooltip = {
    trigger: 'axis'
  }
  option.xAxis = [{
    type: 'category',
    boundaryGap: false,
    data: ['', ...xData, ''],
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    axisLabel: {
      rotate: -25,
      fontSize: 10
    },
    axisTick: {
      show: false
    }
  }]
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#fff'
    },
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    splitLine: {
      show: false
    },
    axisTick: {
      inside: true
    }
  }]
  option.series = [{
    data: [0, ...barData, 0],
    type: 'line',
    symbol: 'none',
    lineStyle: {
      width: 1,
      color: '#ef6606'
    },
    areaStyle: {
      normal: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#ef6606'
        },
        {
          offset: 0.5,
          color: 'rgba(239, 102, 6, 0.7)'
        },
        {
          offset: 0.8,
          color: 'rgba(239, 102, 6, 0.5)'
        },
        {
          offset: 1,
          color: 'rgba(239, 102, 6, 0.2)'
        }])
      }
    }
  }]
  return option
}

export const initOptionTreemap = function (legendData, chartData) {
  let option = {}
  let colors = ['#65c4d7', '#168fff', '#6ab4a0']
  chartData.forEach((item, index) => {
    item['color'] = [colors[index % 3]]
  })
  option.tooltip = {
    show: true,
    formatter: function (params) {
      return params['treePathInfo'][1]['name'] + '<br />' + params['treePathInfo'][2]['name'] + '：' + params['treePathInfo'][2]['value'] + 'L'
    }
  }
  option.legend = {
    data: legendData,
    orient: 'vertical',
    right: '10%',
    top: '10%',
    textStyle: {
      color: '#fff'
    }
  }
  option.backgroundColor = 'rgba(0,0,0,0)'
  option.series = [{
    type: 'treemap',
    roam: false,
    nodeClick: false,
    breadcrumb: {
      show: false
    },
    label: {
      ellipsis: false
    },
    itemStyle: {
      gapWidth: 0.5
    },
    data: chartData
  }]
  return option
}



// WEBPACK FOOTER //
// ./src/chartTools.js